import { useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { GoldButton } from '@/components/common/GoldButton';
import { HeroSection } from '@/components/common/HeroSection';
import { OptionCard } from '@/components/home/OptionCard';
import { OptionList } from '@/components/home/OptionList';
import { StatsRow } from '@/components/home/StatsRow';
import { homeOptions, t } from '@/i18n';
import anim from '@/styles/animations.module.css';
import styles from './HomePage.module.css';

export function HomePage() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const navigate = useNavigate();

  const onCta = () => {
    navigate('/spread');
  };

  if (isDesktop) {
    return (
      <div className={[anim.fadeIn, styles.desktopRoot].join(' ')}>
        <header className={styles.desktopHero}>
          <div className={styles.desktopHeroInner}>
            <div>
              <h1 className={styles.desktopTitle}>{t.auth.brandName}</h1>
              <p className={styles.desktopSub}>{t.home.pickOption}</p>
            </div>
            <div className={styles.desktopHeroMark} aria-hidden>
              {String.fromCodePoint(0x2726)}
            </div>
          </div>
        </header>

        <div className={styles.desktopBody}>
          <h2 className={styles.pickTitle}>{t.home.pickOption}</h2>
          <div className={styles.optionGrid}>
            {homeOptions.map((o) => (
              <OptionCard
                key={o.title}
                layout="stack"
                icon={o.icon}
                title={o.title}
                description={o.description}
                onClick={() => navigate(`/spread?mode=${o.mode}`)}
              />
            ))}
          </div>
          <StatsRow />
        </div>
      </div>
    );
  }

  return (
    <div className={anim.fadeIn}>
      <HeroSection title={t.auth.brandName} subtitle={t.home.pickOption} />
      <section className={styles.sec}>
        <OptionList>
          {homeOptions.map((o) => (
            <OptionCard
              key={o.title}
              icon={o.icon}
              title={o.title}
              description={o.description}
              onClick={() => navigate(`/spread?mode=${o.mode}`)}
            />
          ))}
        </OptionList>
        <div className={styles.cta}>
          <GoldButton onClick={onCta}>{t.nav.newSpread}</GoldButton>
        </div>
        <StatsRow />
      </section>
    </div>
  );
}
